// Zawgyi → Unicode on input (NFR-L10N-2), using Google's myanmar-tools.
// The library is vendored (see tools/vendor/myanmar-tools.mjs) because the npm
// package ships unbuilt sources.
import { ZawgyiDetector } from './vendor/zawgyi_detector';
import { ZawgyiConverter } from './vendor/zawgyi_converter';

let detector: { getZawgyiProbability(s: string): number } | null = null;
let converter: { zawgyiToUnicode(s: string): string } | null = null;

function ensure() {
  detector ??= new ZawgyiDetector();
  converter ??= new ZawgyiConverter();
}

export function zawgyiProbability(text: string): number {
  ensure();
  return detector!.getZawgyiProbability(text);
}

/** Returns Unicode text and whether a conversion happened. Threshold 0.9 per Google's guidance. */
export function toUnicode(text: string): { text: string; converted: boolean } {
  if (!/[က-႟]/.test(text)) return { text, converted: false };
  ensure();
  if (detector!.getZawgyiProbability(text) > 0.9) return { text: converter!.zawgyiToUnicode(text), converted: true };
  return { text, converted: false };
}

/** Normalise a name for the blind index: Unicode, lower, collapsed whitespace, no honorific punctuation. */
export function normalizeName(text: string): string {
  return toUnicode(text).text.normalize('NFC').toLowerCase().replace(/[.,]/g, '').replace(/\s+/g, ' ').trim();
}
